// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DKRM","col":"styles_col__2s5IS","actions":"styles_actions__JRAoL","conflict":"styles_conflict__1sfw9"};